var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"poll-activity-chart",style:({ '--height': _vm.height })},[_c('pendo-status-overlay',{attrs:{"state":_vm.aggState}},[_c('div',{ref:"poll-activity",staticClass:"pendo-highcharts-container"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }